import { connect } from "react-redux";
import { updateActiveFaq } from "../../../../../store/action/faqAction";

const FaqHeader = (props) => {
   const { isActive, updateActiveFaq } = props;
   return (
      <div className="app-v2-header-wrapper has-subtitle has-extra">
         <div className="app-v2-header-left">
            <span className="app-v2-header-title">
               Câu hỏi thường gặp
            </span>
            <span className="app-v2-header-subtitle">
               Cung cấp các thông tin khách hàng thường hỏi khi lần đầu tương tác.
               <a target="_blank">
                  Tìm hiểu thêm
               </a>
            </span>
         </div>
         <div className="app-v2-header-extra-wrapper">
            <div className="app-v2-header-extra-item">
               <div className="input-switch input-switch-off app-v2-gtm-fb-comment-enable active-ice-breaker flex-items-center">
                  <span className="text-smaller text-no-bold mr10 text-danger">
                     Tạm ngưng
                  </span>
                  <label>
                     <div className="input-checkbox text-center">
                        <div className="svg-next-icon icon-check ic-check">
                        </div>
                        <div className="svg-next-icon ic-box.svg">
                        </div>
                     </div>
                     <button type="button" className={`app-switch ${!isActive ? "app-switch" : "app-switch-checked"} app-switch-small app-v2-header-extra-item__switch`} onClick={() => updateActiveFaq(!!isActive ? 0 : 1)} >
                        <span className="app-switch-inner"></span>
                        <div className="app-click-animating-node"></div>
                     </button>
                  </label>
                  <span className="text-smaller text-no-bold ml10">
                     Kích hoạt
                  </span>
               </div>
            </div>
         </div>
      </div>
   )
}
const mapStateToProps = (state) => {
   const { faq } = state;
   return {
      isActive: faq.faqs.is_active
   };
};
export default connect(mapStateToProps, {
   updateActiveFaq
})(FaqHeader);